import aboutImage from '../../assets/aboutImage.jpeg';
import styles from './About.module.scss';

function About() {
  return <img src={aboutImage} className={styles.aboutImage} />;
}

export default About;
